(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dangle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dulnair-dangle')) {
    class DulnairDangle extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.events = new AbortController();
        const on = (node, name, fn) => node.addEventListener(name, fn, { signal: this.events.signal });
        this.sock = this.querySelector('.dd-sock');
        this.rope = this.querySelector('.dd-rope path');
        this.dialog = this.querySelector('dialog');
        this.thought = this.querySelector('.dd-thought');
        this.next = this.querySelector('.dd-next');
        this.gift = this.querySelector('.dd-gift');
        this.quotes = [...new Set(this.querySelector('.dd-quotes').textContent.split(/\r?\n/).map(q => q.trim()).filter(Boolean))];
        if (!this.quotes.length) this.quotes = ['Things get better.'];
        this.key = 'dulnair-dangle-v1';
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.x = 0; this.y = 0; this.vx = 0; this.vy = 0;
        this.draw = this.draw.bind(this);
        this.measure();
        on(window, 'resize', () => { this.measure(); this.paint(); });
        on(this.sock, 'pointerdown', e => {
          if (e.button !== 0 || this.busy || this.drag) return;
          this.drag = { id: e.pointerId, x: e.clientX, y: e.clientY, startX: this.x, startY: this.y, time: e.timeStamp, distance: 0 };
          this.vx = this.vy = 0;
          this.sock.setPointerCapture(e.pointerId);
          this.settle();
        });
        on(this.sock, 'pointermove', e => {
          if (!this.drag || this.drag.id !== e.pointerId) return;
          const dx = e.clientX - this.drag.x, dy = e.clientY - this.drag.y;
          this.drag.distance = Math.max(this.drag.distance, Math.hypot(dx, dy));
          const beforeX = this.x, beforeY = this.y;
          const elapsed = Math.max(.008, (e.timeStamp - this.drag.time) / 1000);
          this.drag.time = e.timeStamp;
          const anchor = this.querySelector('.dd-rig').getBoundingClientRect().left;
          const margin = this.sock.offsetWidth / 2 + 8;
          this.x = Math.max(Math.max(-120, margin - anchor), Math.min(Math.min(120, innerWidth - anchor - margin), this.drag.startX + dx * .8));
          this.y = Math.max(-this.length * .45, Math.min(120, this.drag.startY + dy * .78));
          this.vx = Math.max(-600, Math.min(600, (this.x - beforeX) / elapsed)) * .65;
          this.vy = Math.max(-600, Math.min(600, (this.y - beforeY) / elapsed)) * .65;
          if (this.motion.matches) { this.resetRope(); this.paint(); }
        });
        const release = (e, cancelled) => {
          if (!this.drag || this.drag.id !== e.pointerId) return;
          const didPull = this.drag.distance > 12;
          if (e.timeStamp - this.drag.time > 90) this.vx = this.vy = 0;
          this.drag = null;
          this.restingFrames = 0;
          if (this.sock.hasPointerCapture(e.pointerId)) this.sock.releasePointerCapture(e.pointerId);
          this.settle();
          if (didPull) { this.suppressUntil = performance.now() + 700; if (!cancelled) this.reveal(); }
        };
        on(this.sock, 'pointerup', e => release(e, false));
        on(this.sock, 'pointercancel', e => release(e, true));
        on(this.sock, 'lostpointercapture', e => release(e, true));
        on(this.sock, 'click', e => {
          if (e.detail && performance.now() < (this.suppressUntil || 0)) return;
          this.y = 35; this.x = 8; this.settle(); this.reveal();
        });
        on(this.querySelector('.dd-close'), 'click', () => this.dialog.close());
        on(this.dialog, 'close', () => {
          document.documentElement.style.overflow = this.previousOverflow ?? '';
          this.sock.focus({ preventScroll: true });
        });
        on(this.next, 'click', () => { this.gift.hidden = true; this.showQuote(); });
        on(document, 'visibilitychange', () => {
          if (document.hidden) { cancelAnimationFrame(this.frame); this.frame = null; }
          else this.settle();
        });
        on(document, 'shopify:section:unload', e => {
          if (e.detail.sectionId === this.dataset.section) this.remove();
        });
        this.paint();
        if (!this.motion.matches) { this.x = 12; this.settle(); }
        if (this.parentElement !== document.body) document.body.append(this);
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this.events?.abort(); this.request?.abort(); cancelAnimationFrame(this.frame);
          if (this.dialog?.open) document.documentElement.style.overflow = this.previousOverflow ?? '';
          this.ready = false;
        });
      }
      read(key, fallback) { try { return JSON.parse(localStorage.getItem(key)) ?? this.memory?.[key] ?? fallback; } catch { return this.memory?.[key] ?? fallback; } }
      save(key, value) { (this.memory ||= {})[key] = value; try { localStorage.setItem(key, JSON.stringify(value)); } catch {} }
      measure() {
        this.length = parseFloat(getComputedStyle(this).getPropertyValue('--dd-cord')) || 110;
        this.resetRope();
      }
      resetRope() {
        this.points = Array.from({ length: 17 }, (_, i) => {
          const x = this.x * i / 16, y = (this.length + this.y) * i / 16;
          return { x, y, oldX: x, oldY: y };
        });
      }
      stepRope(dt) {
        const points = this.points, end = points.length - 1;
        const slack = Math.max(0, this.length - Math.hypot(this.x, this.length + this.y));
        for (let i = 1; i < end; i++) {
          const p = points[i], x = p.x, y = p.y;
          p.x += (p.x - p.oldX) * .975 + Math.sin(i / end * Math.PI) * slack * .012 * dt * 120;
          p.y += (p.y - p.oldY) * .975 + 1300 * dt * dt;
          p.oldX = x; p.oldY = y;
        }
        const distance = Math.hypot(this.x, this.length + this.y);
        const segment = Math.max(this.length, distance) / end;
        for (let pass = 0; pass < 10; pass++) {
          points[0].x = 0; points[0].y = 0;
          points[end].x = this.x; points[end].y = this.length + this.y;
          for (let i = 0; i < end; i++) {
            const a = points[i], b = points[i + 1];
            const dx = b.x - a.x, dy = b.y - a.y;
            const length = Math.hypot(dx, dy) || .001;
            const weightA = i === 0 ? 0 : 1, weightB = i + 1 === end ? 0 : 1;
            const correction = (length - segment) / length / (weightA + weightB);
            a.x += dx * correction * weightA; a.y += dy * correction * weightA;
            b.x -= dx * correction * weightB; b.y -= dy * correction * weightB;
          }
        }
        points[0].x = 0; points[0].y = 0;
        points[end].x = this.x; points[end].y = this.length + this.y;
      }
      paint() {
        const points = this.points;
        const angle = Math.max(-32, Math.min(32, -this.x * .24 + this.vx * .012));
        this.sock.style.transform = `translate(calc(-50% + ${this.x}px), ${this.y}px) rotate(${angle}deg)`;
        let path = 'M200 0';
        for (let i = 1; i < points.length - 1; i++) {
          const a = points[i], b = points[i + 1];
          path += ` Q${200 + a.x} ${a.y} ${200 + (a.x + b.x) / 2} ${(a.y + b.y) / 2}`;
        }
        path += ` L${200 + this.x} ${this.length + this.y}`;
        this.rope.setAttribute('d', path);
      }
      settle() {
        if (this.motion.matches) {
          this.x = this.y = this.vx = this.vy = 0;
          this.resetRope(); this.paint(); return;
        }
        if (!this.frame && !document.hidden) {
          this.last = performance.now(); this.restingFrames = 0;
          this.frame = requestAnimationFrame(this.draw);
        }
      }
      draw(now) {
        this.frame = null;
        const elapsed = Math.min((now - this.last) / 1000, .032); this.last = now;
        const steps = Math.max(1, Math.ceil(elapsed / (1 / 120))), dt = elapsed / steps;
        for (let step = 0; step < steps; step++) {
          if (!this.drag) {
            this.vx += (-38 * this.x - 4.2 * this.vx) * dt;
            this.vy += (-95 * this.y - 5.2 * this.vy) * dt;
            this.x += this.vx * dt; this.y += this.vy * dt;
            if (this.y < -this.length * .6) { this.y = -this.length * .6; this.vy = Math.abs(this.vy) * .35; }
          }
          this.stepRope(dt);
        }
        this.paint();
        const moving = Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.vx) + Math.abs(this.vy) > .3;
        this.restingFrames = moving || this.drag ? 0 : this.restingFrames + 1;
        if (this.restingFrames < 18) this.frame = requestAnimationFrame(this.draw);
        else { this.x = this.y = this.vx = this.vy = 0; this.resetRope(); this.paint(); }
      }
      random(n) { return Math.floor(crypto.getRandomValues(new Uint32Array(1))[0] / 4294967296 * n); }
      showQuote() {
        const k = this.key + '-quotes';
        const raw = this.read(k, {});
        const stored = raw && typeof raw === 'object' ? raw : {};
        let seen = Array.isArray(stored.seen) ? stored.seen.filter(q => this.quotes.includes(q)) : [];
        let options = this.quotes.filter(q => !seen.includes(q));
        if (!options.length) { seen = []; options = this.quotes.filter(q => q !== stored.last); }
        if (!options.length) options = this.quotes;
        const quote = options[this.random(options.length)];
        this.save(k, { seen: [...seen, quote], last: quote });
        this.thought.textContent = quote;
      }
      async coupon() {
        if (!this.dataset.endpoint || this.dataset.editor === 'true') return null;
        let url;
        try { url = new URL(this.dataset.endpoint); if (url.protocol !== 'https:') return null; } catch { return null; }
        const day = new Date().toISOString().slice(0, 10);
        const dailyKey = this.key + '-day';
        if (this.read(dailyKey, '') === day) return null;
        let visitor = this.read(this.key + '-visitor', '');
        if (typeof visitor !== 'string' || !/^[a-f0-9-]{36}$/i.test(visitor)) { visitor = crypto.randomUUID(); this.save(this.key + '-visitor', visitor); }
        this.request = new AbortController();
        const timeout = setTimeout(() => this.request.abort(), 3000);
        try {
          const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ visitor }), signal: this.request.signal, credentials: 'omit', cache: 'no-store' });
          if (!response.ok) return null;
          const result = await response.json();
          if (result.type !== 'quote' && result.type !== 'coupon') return null;
          this.save(dailyKey, day);
          if (result.type === 'coupon' && typeof result.code === 'string' && /^[A-Za-z0-9_-]{3,80}$/.test(result.code)) return result;
        } catch {} finally { clearTimeout(timeout); }
        return null;
      }
      async reveal() {
        if (this.busy || this.dialog.open) return;
        this.busy = true; this.dataset.used = ''; this.sock.setAttribute('aria-busy', 'true');
        const [coupon] = await Promise.all([this.coupon(), new Promise(resolve => setTimeout(resolve, this.motion.matches ? 0 : 950))]);
        if (!this.isConnected) { this.busy = false; return; }
        this.gift.hidden = !coupon;
        if (coupon) {
          this.thought.textContent = this.querySelector('.dd-gift-title').textContent;
          this.querySelector('.dd-code').textContent = coupon.code;
          this.querySelector('.dd-offer').textContent = typeof coupon.message === 'string' ? coupon.message : '';
          const root = this.dataset.root || '/';
          this.querySelector('.dd-apply').href = `${root}discount/${encodeURIComponent(coupon.code)}?redirect=${encodeURIComponent(root + 'collections/all')}`;
        } else this.showQuote();
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.sock.removeAttribute('aria-busy'); this.busy = false;
      }
    }
    customElements.define('dulnair-dangle', DulnairDangle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
